import styled, {DefaultTheme, StyledComponentProps} from 'styled-components';
import {ITypography, Typography} from './typography';
import {
  getFontSizeFromTheme,
  getFontWeightFromTheme,
  getLineHeightFromTheme,
} from '../../ui-utils';

export type Headline1Props = StyledComponentProps<
  'h1',
  DefaultTheme,
  ITypography,
  'kind' | 'align'
>;

/**
 Use to display higher hierarchical content
 **/
export const Headline1 = styled.h1<ITypography>`
  ${Typography};

  font-size: ${getFontSizeFromTheme('headline1')};
  font-weight: ${getFontWeightFromTheme('bold')};
  line-height: ${getLineHeightFromTheme('headline1')};
`;
